import clsx from 'clsx';
import { useMediaQuery } from 'react-responsive';

import { ExclusiveDealsBenefit, ImpactBenefit, ShippingBenefit } from 'features/paid-membership/Benefits';

import OddsEndsBenefit from '../Benefits/OddsEndsBenefit';

/**
 * BenefitsList component that displays a list of membership benefits
 * @param {Object} props - Component props
 * @param {string} [props.bgColor=''] - Background color class for the benefits
 * @param {'horizontal' | 'responsive'} [props.layout='responsive'] - Layout orientation for the benefits list
 * @returns {JSX.Element} Rendered benefits list
 */
function BenefitsList({ bgColor = '', layout = 'responsive' }) {
    const withinHorizontalBreakpoint = useMediaQuery({ maxWidth: 539 });

    const listOrientation = layout === 'horizontal' || withinHorizontalBreakpoint ? 'horizontal' : 'responsive';

    return (
        <ul className={clsx('gap-20', listOrientation === 'horizontal' ? 'flex flex-col' : 'grid grid-cols-4')}>
            <li>
                <ExclusiveDealsBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
            <li>
                <OddsEndsBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
            <li>
                <ShippingBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
            <li>
                <ImpactBenefit layout={listOrientation} bgColor={bgColor} />
            </li>
        </ul>
    );
}

export { BenefitsList };
